module.exports = __webpack_public_path__ + "img/gsb18.4f67a00e.png";